import http from "@/api/http";

// 导航栏
// export const home = () => http.get('/mgm/home')
export const home = () => http.get('/offic/home')//2024.1.31更换

